module.exports = __webpack_public_path__ + "img/Gameboard_Loansbox.61257ace.png";